import {type GatewayConfiguration} from '../../models/GatewayConfiguration';
import {getLocaleText} from '../../util/translation';
import cardImageURL from '../../../img/marks/credit-card-regular.svg';
import cardBadgeURL from '../../../img/badge/card.svg';
import {type PoyntGateway} from './poynt';
import {PoyntCardElement} from '../../../../native-checkout/ts/poynt/class-poynt-card-payment';
import {$qs} from '../../../../@shared/ts/dom';
import {type NoncePayload, type PoyntOptions} from '../../../../native-checkout/ts/poynt/types';
import {Feature} from '../../reducers/environmentReducer';
import {FeatureFlag} from '../../../../@type/features';

function initPoyntCardMethod(): PoyntGateway {
	const config: GatewayConfiguration = {
		name: Feature.metadata<string>(FeatureFlag.POYNT_CARD_GATEWAY, 'title') ?? getLocaleText('Card'),
		gatewayId: 'peachpay_poynt_card',
		description: '',
		assets: {
			title: {src: cardImageURL},
			badge: {src: cardBadgeURL},
		},
	};

	let cardElement: PoyntCardElement | null = null;

	return {
		config,
		init(options: PoyntOptions) {
			const customCSS = {
				iFrame: {
					border: '0px',
					borderRadius: '0px',
					boxShadow: 'none',
					height: '84px',
					width: '-webkit-fill-available',
				},
			};

			// Render Poynt card element
			const $container = $qs('#pp-pms-new div.pp-pm-saved-option[data-gateway="peachpay_poynt_card"]');
			if (!$container) {
				return;
			}

			$container.setAttribute('id', 'pp-poynt-new');
			$container.style.padding = '0px';
			$container.style.border = '0px';
			$container.style.width = '-webkit-fill-available';
			cardElement = new PoyntCardElement(options);
			cardElement.mount('pp-poynt-new', customCSS);
		},
		async tokenize(payload: NoncePayload) {
			if (!cardElement) {
				return {
					error: 'Poynt Card element not found while attempting to tokenize card.',
				};
			}

			const result = cardElement.tokenize(payload);
			return result;
		},
	};
}

export {initPoyntCardMethod};
